import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FAQAccordion from "../components/FAQAccordion";

function FAQPage() {
  return (
    <div className="font-inter flex flex-col min-h-screen overflow-hidden">
      <Navbar />

      <div
        className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24"
        style={{
          marginTop: "calc((100vh - 10rem) / 15)",
          marginBottom: "calc((100vh - 10rem) / 10)",
        }}
      >
        <div className="text-center px-4 sm:px-6 lg:px-10 font-inter">
          <h2 className="text-4xl xl:text-5xl 2xl:text-6xl font-bold my-6 lg:mb-6 text-[#111827]">
            Frequently Asked Questions
          </h2>
          <p className="text-[#4E5562] mt-4 text-sm sm:text-base xl:text-base 2xl:text-lg xl:mt-4 2xl:mt-8 mx-4 sm:mx-14 md:mx-22 lg:mx-0">
            Get answers to the most common questions our users have.
          </p>
          <p className="text-[#4E5562] mb-8 mt-2 2xl:mb-8 text-sm sm:text-base xl:text-base 2xl:text-lg mx-4 sm:mx-14 md:mx-22 lg:mx-0">
            If you can't find what you're looking for, feel free to contact us.
          </p>
        </div>

        <div className="flex-grow px-4 sm:px-6 lg:px-10">
          <FAQAccordion />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default FAQPage;